module.exports = "/_next/static/images/img__feedbacks_right_top_desktop-2415e77ada0cd61f3ef563f5382bcb59.png";